import { useSelector } from 'react-redux';
import ButtonIconGhostMedium from '../../common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../icon/icon';
import './RightDoorHandleCustomDesignMenu.scss';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { useTranslation } from 'react-i18next';
import CardProduct from '../../card/CardProduct/CardProduct';
import CardProductClick from '../../card/CardProduct/CardProductClick';

const RightDoorHandleCustomDesignMenu = ({ open, onClose, onClickCard }) => {
  const { t } = useTranslation();
  const { door } = useSelector(state => state.doorAndHandle || {});

  return (
    <RightMenuDesign
      open={open}
      classNames={{ root: 'top-16', content: '!p-0 gap-0' }}
      header={
        <div className="flex items-center gap-8">
          <ButtonIconGhostMedium
            icon={<Icon.ICArrowBack />}
            onClick={onClose}
          />
          <span className="text-title-large text-nowrap">{t('Customize')}</span>
        </div>
      }
      content={
        <>
          <div className="grid grid-cols-2 p-8 justify-start items-start gap-2 self-stretch overflow-auto">
            <>
              {door?.data?.handles?.map((md, i) => {
                const name = getValueFromString(md.name);
                const description = getValueFromString(md.description);

                return (
                  <CardProductClick
                    key={i}
                    md={md}
                    title={name}
                    description1={description}
                    description2={md.size}
                    // description2={
                    //   <span className="text-label-small">
                    //     {md.price.toLocaleString('vi-VN', {
                    //       style: 'currency',
                    //       currency: 'VND',
                    //     })}
                    //   </span>
                    // }
                    moduleType={'moduleType'}
                    onClick={onClickCard}
                  />
                );
              })}
            </>
          </div>
        </>
      }
    />
  );
};

export default RightDoorHandleCustomDesignMenu;
